// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2xs7z","Icon":"Languages_Icon__3SRL9","LanguagesSelect":"Languages_LanguagesSelect__2Yy70","minimalist":"Languages_minimalist__1KTS_"};